// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"724":"a009d3cd","2922":"01ecf39a","8192":"a009d3cd","9369":"a009d3cd","9898":"f1317ab3"}[chunkId] + ".chunk.css";
};